var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-time-picker", {
    staticClass: "time-picker",
    class: { "dnx-readonly": _vm.readonly },
    attrs: {
      "input-class": "form-control",
      format: "HH:mm:ss",
      disabled: _vm.readonly,
      "hour-range": _vm.enabledHourRange,
      "minute-range": _vm.enabledMinuteRange,
      "second-range": _vm.enabledSecondRange,
      "hide-clear-button": ""
    },
    model: {
      value: _vm.model,
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }